import React from 'react';
import { Icon } from '@reverse-hr/design-system';

const Scroller = ({
  modifier = '',
  icon = 'icn-short-right',
  onScroll = () => {},
}) => {
  return (
    <div className={`c-app-scroller ${modifier}`}>
      <button className="c-app-scroller__button" onClick={onScroll}>
        <span className="c-app-scroller__icon">
          <Icon size={20} name={icon} />
        </span>
      </button>
    </div>
  );
};

export default Scroller;
